define('fukit/collection/base.collection',['require','exports','module','marionette','datakit/datakit','evicommon/search.util','evicommon/pagination.util','evicommon/spf/model/sort','evicommon/spf/model/paginate'],function(require, exports, module) {
  //prettier-ignore
  var Mn             = require('marionette'),
      DataKit        = require('datakit/datakit'),
      SearchUtil     = require('evicommon/search.util'),
      PaginationUtil = require('evicommon/pagination.util'),
      SortModel      = require('evicommon/spf/model/sort'),
      PaginateModel  = require('evicommon/spf/model/paginate');

  var BaseCollection = DataKit.HalModel.Collection.extend({
    // auto-fetch the collection
    // if the pagination model changes
    paginateAutoFetch: true,
    // auto-fetch the collection
    // when the sort model changes
    sortAutoFetch: true,
    // do not auto-fetch a collection
    // when the filter collection changes
    filtersAutoFetch: false,
    // Use search service filter API and initialize searchServiceQueryFields
    useSearchService: false,
    searchServiceQueryFields: [],
    additionalSearchServiceParams: {},

    relationshipTypes: {
      hasMany: DataKit.AbstractHasManyRelationshipType.extend({
        supportedResourceClass: Backbone.Collection,
        initialize: function() {
          DataKit.AbstractHasManyRelationshipType.prototype.initialize.apply(this, arguments);
          this.foreignFilter = this.resource.filters.add({ field: this.foreignKey, hidden: true });
        },
        configureResource: function() {
          this.foreignFilter.set(
            {
              value: this.foreignModel.id,
            },
            { ignoreAutoFetch: true }
          );
        },
      }),
    },

    constructor: function(models, options) {
      DataKit.HalModel.Collection.apply(this, arguments);

      this.options = options || {};

      var filters = Mn._getValue(this.getOption('filters'), this);
      // collection defines its own sort so we cannot use Mn._getValue
      //prettier-ignore
      var sort = this.getOption('sort'),
          paginate = Mn._getValue(this.getOption('paginate') || this.getOption('page'));

      this.filters = this.getOption('useSearchService')
        ? SearchUtil.createSearchServiceCriteria(
            this.getOption('searchServiceQueryFields'),
            this.getOption('additionalSearchServiceParams')
          )
        : SearchUtil.createTraditionalSearchCriteria();

      this.sort = PaginationUtil.createSort();
      this.paginate = PaginationUtil.createPaginate();

      if (filters) {
        this.filters.add(filters);
      }
      if (sort && sort.field) {
        this.sort.set(SortModel.SORT_FIELD, sort.field);
        this.sort.set(SortModel.SORT_DIRECTION, sort.direction || SortModel.ASCENDING);
      }
      if (paginate && paginate.number) {
        this.paginate.set(PaginateModel.PAGE, paginate.number);
      }
      if (paginate && paginate.size) {
        this.paginate.set(PaginateModel.SIZE, paginate.size);
      }

      this.addAdapter(
        SearchUtil.createSearchAdapter(this.filters, {
          autoFetch: this.getOption('filtersAutoFetch'),
        })
      )
        .addAdapter(
          PaginationUtil.createSortAdapter(this.sort, {
            autoFetch: this.getOption('sortAutoFetch'),
          })
        )
        .addAdapter(
          PaginationUtil.createPaginateAdapter(this.paginate, {
            autoFetch: this.getOption('paginateAutoFetch'),
          })
        );
    },

    getOption: Mn.proxyGetOption,
  });

  module.exports = BaseCollection;
});

